import useSWR from 'swr';
import {
    getSoyMultiplierItemFromAPI,
    getSoyMultiplierItemsFromAPI,
    getSoyMultipliersFromAPI,
    getSoyMultiplierZonesFromAPI,
} from '/@/store/multipliers/apiProviders';

export const useAllSoyMultipliers = (zoneId) => useSWR({ key: 'allSoyMultipliers', zoneId }, getSoyMultipliersFromAPI);
export const useSoyMultiplier = (id) => useSWR({ key: 'soyMultiplierItem', id }, getSoyMultiplierItemFromAPI);
export const useSoyMultipliers = (ids) => useSWR({ key: 'soyMultiplierItems', ids }, getSoyMultiplierItemsFromAPI);
export const useSoyMultipliersZones = (country) =>
    useSWR({ key: 'soyMultiplierZones', country }, getSoyMultiplierZonesFromAPI);
